export default {"src":"/_next/static/media/twitterIcon.ca46ef7a.svg","height":14,"width":16};